import { ApexOptions } from "apexcharts";
import { numberWithCommas } from "../../helpers/numberWithCommas";
import { AggregateResponse } from "../../types/dashboard/DashboardConfig";

export interface ChartConfig {
  type: "pie" | "line" | "bar";
  options: ApexOptions;
  series: ApexAxisChartSeries | number[];
}

const yAxisFormatter = (v: number) => numberWithCommas(Math.floor(v)) ?? "0";

export function buildChartConfig(
  data: AggregateResponse,
  chartType: string,
  title: string,
  primaryColor: string | undefined,
  customColors: string[] | undefined,
): ChartConfig | null {
  if (data.labels.length === 0) return null;

  if (chartType === "pie") {
    const options: ApexOptions = {
      chart: { type: "pie", animations: { enabled: false } },
      labels: data.labels,
      colors: customColors,
      legend: { position: "bottom" },
    };
    return { type: "pie", options, series: data.values };
  }

  if (chartType === "line") {
    const options: ApexOptions = {
      chart: { type: "line", toolbar: { show: true }, animations: { enabled: false } },
      xaxis: { categories: data.labels },
      yaxis: { labels: { formatter: yAxisFormatter } },
      colors: [primaryColor],
      stroke: { curve: "smooth", width: 2 },
      markers: { size: 4 },
    };
    return { type: "line", options, series: [{ name: title, data: data.values }] };
  }

  // Default: bar chart
  const options: ApexOptions = {
    chart: { type: "bar", toolbar: { show: true }, animations: { enabled: false } },
    xaxis: { categories: data.labels },
    yaxis: { labels: { formatter: yAxisFormatter }, forceNiceScale: true },
    plotOptions: { bar: { borderRadius: 4, horizontal: false } },
    colors: [primaryColor],
    dataLabels: { enabled: false },
  };
  return { type: "bar", options, series: [{ name: title, data: data.values }] };
}
